





















































import Vue, { PropType } from 'vue';
import Component, { mixins } from 'vue-class-component';

import { locales } from './locales';
import { DataListIcons, IDataList } from './types';

import DataListItem from './DataListItem';
import DataListLoading from './DataListLoading';

const Props = Vue.extend({
	props: {
		/** The items to display */
		items: {
			type: Array as PropType<IDataList>,
			required: true
		},
		icons: {
			type: Object as PropType<DataListIcons | undefined>,
			default: undefined
		},
		// Title options
		listTitle: {
			type: String,
			default: undefined
		},
		titleClass: {
			type: String,
			default: 'mb-3 text-h5'
		},
		row: {
			type: Boolean,
			default: false
		},
		flex: {
			type: Boolean,
			default: false
		},
		/** The text to display as fallback */
		placeholder: {
			type: String,
			default: locales.placeholder
		},
		/** The list min-width */
		minWidth: {
			type: String,
			default: undefined
		},
		/** The item width */
		itemWidth: {
			type: String,
			default: '200px'
		},
		/** Loading mode */
		loading: {
			type: Boolean,
			default: false
		},
		/** The number of items to display during loading */
		itemsNumberLoading: {
			type: Number,
			default: 1
		},
		/** Display the heading while loading */
		headingLoading: {
			type: Boolean,
			default: false
		},
		/** Render the value as plain HTML */
		renderHtmlValue: {
			type: Boolean,
			default: false
		}
	}
});

const MixinsDeclaration = mixins(Props);

/**
 * DataList is a component that displays list of
 * items containing key/value
 */
@Component({
	components: {
		DataListItem,
		DataListLoading
	}
})
export default class DataList extends MixinsDeclaration {
	get listClass(): string {
		return this.flex ? 'flex-wrap' : 'flex-column';
	}

	getIcon(iconName?: string): string | null {
		if (!iconName || !this.icons) {
			return null;
		}

		return this.icons[iconName];
	}
}
